var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18180_90904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5H34C37.0376 0.5 39.5 2.96243 39.5 6V34C39.5 37.0376 37.0376 39.5 34 39.5H6C2.96243 39.5 0.5 37.0376 0.5 34V6C0.5 2.96243 2.96243 0.5 6 0.5Z",
    fill: "#F0F2F6",
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.503 12.3127C18.224 13.0338 18.5017 14.0886 18.224 15.0711C19.1132 14.5367 20.1307 14.2566 21.1667 14.2566H21.1877C22.7116 14.2613 24.1701 14.8727 25.2412 15.9555C26.1 16.8586 27.5282 16.8936 28.4289 16.0349C29.332 15.1761 29.3671 13.7479 28.5083 12.8472C28.4873 12.8238 28.4639 12.8028 28.4407 12.7794C26.527 10.8449 23.9204 9.7528 21.1994 9.74807H21.1597C19.1225 9.74344 17.1319 10.3502 15.4424 11.489H15.5054C16.2545 11.489 16.9709 11.7853 17.5007 12.3151L17.503 12.3127Z",
    fill: "#1773EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8009 23.4219C26.2058 23.4219 25.6341 23.6576 25.2117 24.0753C24.1382 25.1441 22.6844 25.7439 21.1676 25.7439H21.1466C20.1081 25.7439 19.0883 25.4568 18.2016 24.9154C18.2692 25.1604 18.3018 25.4148 18.3018 25.6691C18.3018 27.2257 17.0394 28.4881 15.4828 28.4881H15.4082C17.0954 29.6363 19.0883 30.2547 21.1302 30.2571H21.1698C23.8768 30.2617 26.4742 29.1906 28.3901 27.2793C29.2745 26.4019 29.2792 24.9738 28.4041 24.0893C27.9817 23.6622 27.4029 23.4219 26.8032 23.4219H26.8009Z",
    fill: "#E44F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4886 23.6722C14.016 23.1425 14.7348 22.8437 15.4839 22.8461C15.7429 22.8461 15.9996 22.8811 16.247 22.9511C15.1502 21.1286 15.1548 18.8487 16.2586 17.0307C14.7558 17.4438 13.2039 16.5594 12.7909 15.0566C12.7232 14.8115 12.6906 14.5595 12.6906 14.3075V14.2305C10.3313 17.6958 10.3219 22.2487 12.6626 25.7258V25.6675C12.6626 24.9184 12.9566 24.2019 13.4886 23.6722Z",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5097 11.9902C14.8679 11.9902 14.4198 12.2562 13.8761 12.8C13.3581 13.3181 13.1947 13.7708 13.1924 14.3098C13.1924 15.591 14.2308 16.6271 15.512 16.6271C16.7931 16.6271 17.8293 15.5886 17.8293 14.3075C17.8293 13.0287 16.7908 11.9902 15.512 11.9902H15.5097Z",
    fill: "#1773EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1592 25.6705C13.1592 26.3098 13.4252 26.7602 13.9689 27.3039C14.487 27.822 14.9397 27.9877 15.4787 27.9877C16.7553 27.983 17.7867 26.9469 17.782 25.6705C17.7774 24.3939 16.7413 23.3625 15.4647 23.3672C14.1906 23.3718 13.1615 24.4033 13.1615 25.6775V25.6705H13.1592Z",
    fill: "#E44F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18180_90904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentful);
export default __webpack_public_path__ + "static/media/Contentful.cc51cbc7b901be3bf2db7a2505793886.svg";
export { ForwardRef as ReactComponent };